import * as React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export default function Step4({
  templateData,
  setTemplateData,
  handleFileUpload,
}) {
  return (
    <Stack
      spacing={4}
      sx={{
        maxWidth: '700px',
        marginLeft: 'auto',
        marginRight: '25px',
      }}
    >
      <Typography
        variant="h5"
        gutterBottom
        component="div"
        sx={{ marginBottom: '10px', width: '100%' }}
      >
        Select Image Content
      </Typography>
      <TextField
        id="outlined-controlled"
        label="Image URL"
        value={templateData.content_image_url}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setTemplateData({
            ...templateData,
            content_image_url: event.target.value,
          });
        }}
      />
      <Typography variant="h6" gutterBottom component="div" align="center">
        Or
      </Typography>

      <Button
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        startIcon={<CloudUploadIcon />}
        sx={{ color: 'white' }}
      >
        Upload Image
        <VisuallyHiddenInput
          type="file"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            handleFileUpload(event.target.files)
          }
        />
      </Button>
    </Stack>
  );
}
